import React from 'react';
import { Edit, NumberInput, SimpleForm, TextInput, useGetOne, useGetRecordId } from 'react-admin';
import EnumSelectInput from 'components/Enum/EnumSelectInput';
import { transformShiftTypes } from 'resources/professional_saas_details/utils';
import MoneyInput from 'components/MoneyInput';

const transformPayload = (data) => {
  const { job_shift_types: jobShiftTypes, ...rest } = data;
  return { ...rest, shift_types: jobShiftTypes };
};

const ProfessionalSaasDetailEdit = () => {
  const id = useGetRecordId();
  const { data: record } = useGetOne('ProfessionalSaasDetail', { id });
  if (!record) {
    return null;
  }
  return (
    <Edit mutationMode="pessimistic" redirect="show" transform={transformPayload}>
      <SimpleForm defaultValues={{ job_shift_types: transformShiftTypes(record.shift_types) }}>
        <NumberInput label="Max Weekly hours" source="max_weekly_hours" />
        <MoneyInput label="Hourly Rate" source="hourly_rate_cents" />
        <EnumSelectInput label="Shift Types" source="job_shift_types" multiple />
        <EnumSelectInput label="Employment Type" source="employment_type" />
        <EnumSelectInput label="Offboarded Reason" emptyText="None" source="offboarded_reason" />
      </SimpleForm>
    </Edit>
  );
};

export default ProfessionalSaasDetailEdit;
